var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataObservabilityClicked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#DAE3F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_10702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 7.5V18.5H35.5V7.5H31.5ZM34.5 17.5H32.5V8.5H34.5V17.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 12.558C26.18 12.272 25.8465 12.004 25.5 11.7555V11.5H25.1235C23.175 10.211 20.8715 9.5 18.5 9.5H18V22H30.5V21.5C30.5 20.484 30.3655 19.479 30.113 18.5H30.5V9.5H26.5V12.558ZM29.489 21H19V10.511C20.415 10.576 21.7935 10.9195 23.0645 11.5H21.5V18.5H25.5V13.0335C25.85 13.3225 26.186 13.629 26.5 13.962V18.5H29.078C29.309 19.3155 29.4505 20.1525 29.489 21ZM24.5 12.5V17.5H22.5V12.5H24.5ZM27.5 10.5H29.5V17.5H27.5V10.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6465 19.6484L8.39648 23.8984L9.10358 24.6055L13.3536 20.3555L12.6465 19.6484Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C10.5 19.173 9.827 18.5 9 18.5C8.173 18.5 7.5 19.173 7.5 20C7.5 20.827 8.173 21.5 9 21.5C9.827 21.5 10.5 20.827 10.5 20ZM8.5 20C8.5 19.724 8.724 19.5 9 19.5C9.276 19.5 9.5 19.724 9.5 20C9.5 20.276 9.276 20.5 9 20.5C8.724 20.5 8.5 20.276 8.5 20Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 22.5C12.173 22.5 11.5 23.173 11.5 24C11.5 24.827 12.173 25.5 13 25.5C13.827 25.5 14.5 24.827 14.5 24C14.5 23.173 13.827 22.5 13 22.5ZM13 24.5C12.724 24.5 12.5 24.276 12.5 24C12.5 23.724 12.724 23.5 13 23.5C13.276 23.5 13.5 23.724 13.5 24C13.5 24.276 13.276 24.5 13 24.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4285 30.2215C27.7795 28.231 28.5 25.9195 28.5 23.5V23H17V11.5H16.5C16.006 11.5 15.5035 11.5435 15 11.607V4.5H4.5V11.5H10.793L11.7695 12.4765C7.3925 14.356 4.5 18.689 4.5 23.5C4.5 30.1165 9.8835 35.5 16.5 35.5C19.4015 35.5 22.1655 34.451 24.3495 32.5565L25.8965 34.1035C26.2005 34.4075 26.6005 34.56 27 34.56C27.3995 34.56 27.7995 34.4075 28.1035 34.1035C28.712 33.495 28.712 32.505 28.1035 31.8965L26.4285 30.2215ZM5.5 10.5V5.5H14V13.293L11.207 10.5H5.5ZM16.5 34.5C10.4345 34.5 5.5 29.5655 5.5 23.5C5.5 18.9545 8.318 14.8765 12.5385 13.2455L15 15.707V12.61C15.3345 12.564 15.669 12.527 16 12.5115V24H27.489C27.4015 25.9725 26.789 27.854 25.71 29.503L24.9125 28.7055C24.9675 28.479 25 28.2435 25 28C25 26.3455 23.6545 25 22 25C20.3455 25 19 26.3455 19 28C19 29.6545 20.3455 31 22 31C22.2435 31 22.479 30.9675 22.7055 30.9125L23.6405 31.8475C21.6475 33.5555 19.136 34.5 16.5 34.5ZM22 30C20.897 30 20 29.103 20 28C20 26.897 20.897 26 22 26C23.103 26 24 26.897 24 28C24 29.103 23.103 30 22 30ZM27.3965 33.3965C27.1775 33.6155 26.8225 33.6155 26.6035 33.3965L23.6865 30.4795C23.998 30.267 24.267 29.998 24.4795 29.6865L27.3965 32.6035C27.615 32.8225 27.615 33.1775 27.3965 33.3965Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.5H6.5V7.5H13V6.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.5H6.5V9.5H13V8.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 27.5H21.5V28.5H22.5V27.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27.5H17V28.5H18V27.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 27.5H15V28.5H16V27.5Z",
    fill: "#003771"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27.5H13V28.5H14V27.5Z",
    fill: "#003771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_10702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataObservabilityClicked);
export default __webpack_public_path__ + "static/media/Data Observability Clicked.b07dd27e93261a26531596f1a90496fc.svg";
export { ForwardRef as ReactComponent };